import { Button, Spinner } from "@adafia/ui";
import { useQuery } from "@tanstack/react-query";
import { Download } from "lucide-react";
import { useParams } from "react-router-dom";
import { getPublicResumeBySlug } from "../api/resume";
import { ResumePreview } from "./Preview/ResumePreview";

export function PublicResume() {
	const { slug } = useParams<{ slug: string }>();

	const { data, isLoading, error } = useQuery({
		queryKey: ["public-resume", slug],
		queryFn: () => getPublicResumeBySlug(slug as string),
		enabled: !!slug,
	});

	const handlePrint = () => window.print();

	if (isLoading) {
		return (
			<div className="flex justify-center items-center min-h-[50vh]">
				<Spinner />
			</div>
		);
	}

	if (error || !data) {
		return (
			<div className="flex flex-col items-center justify-center min-h-[50vh] text-center p-8">
				<h2 className="text-2xl font-bold mb-4">Resume not found</h2>
				<p className="text-muted">
					The resume you are looking for might have been moved or is not public.
				</p>
			</div>
		);
	}

	return (
		<div className="public-resume-view">
			<div className="public-header no-print">
				<div className="max-w-4xl mx-auto px-4 flex justify-end">
					<Button onClick={handlePrint} variant="outline" size="sm">
						<Download size={16} /> Download PDF
					</Button>
				</div>
			</div>
			<div className="public-resume-container max-w-4xl mx-auto py-8 px-4">
				<ResumePreview resume={data} />
			</div>
		</div>
	);
}
